import { ChoiceDialogContentDTO, ChoiceDTO, DialogContentDTO } from "../../../shared/dtos";
import { Direction } from "../../../shared/enum";
import { TextContent } from "../../components/text-content";
import { BasicDialog } from "./basic-dialog";

//let { lazyInject } = getDecorators(container);

export class ConfirmationDialog extends BasicDialog {
    private _selection = 0;

    private _choices: ChoiceDTO[];
    private _textContents: TextContent[] = [];

    constructor(scene: Phaser.Scene, dialog_content: ChoiceDialogContentDTO) {
        super(scene);
        console.log("create confirmation dialog: ", dialog_content);
        this._choices = dialog_content.choices;
    }

    public draw() {
        super.draw();

        const screenWidth = this._callingScene.physics.world.bounds.width;
        const screenHeight = this._callingScene.physics.world.bounds.height;

        // Create text contents first to measure them
        this._choices.forEach((choice, index) => {
            const content = new TextContent(0, 0, choice.choice, this._callingScene);
            this._textContents.push(content);
            this.dialog.add(content);
        });

        // Calculate total width needed for all choices
        const spacing = 60; // Space between choices
        let totalWidth = 0;
        this._textContents.forEach((content, index) => {
            totalWidth += content.width;
            if (index < this._textContents.length - 1) {
                totalWidth += spacing;
            }
        });

        // Center the choices horizontally and position them below the message
        const startX = (screenWidth - totalWidth) / 2;
        const choiceY = screenHeight - 50; // Position in lower part of dialog box

        let currentX = startX;
        this._textContents.forEach((content, index) => {
            content.setPosition(currentX, choiceY);
            currentX += content.width + spacing;
        });

        if (this._textContents.length > 0) {
            this._textContents[0].select();
        }
    }

    // gérer les directions
    public changeSelection(direction: Direction) {
        console.log("change selection");
        if (direction === Direction.LEFT) {
            if (this._selection > 0) {
                this._selection--;
            }
        } else if (direction === Direction.RIGHT) {
            if (this._selection < this._choices.length - 1) {
                this._selection++;
            }
        }
        this._textContents.forEach((textContent) => textContent.unselect());
        this._textContents[this._selection].select();
    }

    public onAction() {
        console.log("choice of value ", this._selection, " (", this._choices[this._selection], ")");
        /*        const choice = {
            'source': this._dialog.scene_id,
            'event_trigger': this._dialog.event_trigger,
            'choice': this._choices[this._selection].value
        }*/

        this._callingScene.events.emit("dialog_choice", this._selection);
    }
}
